import React from "react";
import { useNavigate } from "react-router-dom";
import PasswordChangeDialog from "../../components/PasswordChangeDialog";
import { firstAccessibleRoute } from "../../utils/authoritiesUtils";

// Page du changement de mot de passe obligatoire. Aucune autorisation requise : tout compte connecté
// (expert, agence, siège) y est envoyé par PasswordChangeGuard, puis redirigé vers sa première page accessible.
function ChangePassword() {
    const navigate = useNavigate();
    return (
        <>
            <div style={{ padding: 40, fontFamily: "Poppins, sans-serif", color: "rgba(70, 78, 95, 1)" }}>
                Votre mot de passe doit être modifié avant de continuer.
            </div>
            <PasswordChangeDialog open onSuccess={() => navigate(firstAccessibleRoute() || "/sinistres", { replace: true })} />
        </>
    );
}

export default ChangePassword;
